import { fetchWithTimeout } from "./Timeout";
import { CheckSessionTimeout } from "./CheckSessionTimeout";
export async function GetUserPlaidAccounts(clientUsername){

  const Token = sessionStorage.getItem("Token");
  // const session_id = sessionStorage.getItem("sessionID");

  const header = { Authorization: Token };

  var raw = JSON.stringify({ session_id: Token , client_username : clientUsername });

  var requestOptions = {
    method: "POST",
    redirect: "follow",
    body: raw,
    headers: header,
  };
  if (!CheckSessionTimeout(Token)) {
    try {
      const response = await fetchWithTimeout(
        process.env.REACT_APP_GET_PLAID_USER_ACCOUNTS,
        requestOptions
      );
      const message = await response.json();
      console.log("plaid access",message)
      if (!response.ok) {
        return { status: response.status, error: message.error || message };
      } else {
        return { status: response.status, result: message.result };
      }
    } catch (error) {
      return { status: 0, error: error.message };
    }
  } else {
    return { status: 401 };
  }
}
